import React from 'react';
import { Link } from 'react-router-dom';
import { stats } from './homeData';

function MissionVisionSection() {
  return (
    <section id="mission" className="bg-[#faf7f3] px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[minmax(0,1.1fr)_minmax(360px,0.9fr)] lg:items-start">
        <div>
          <h2 className="text-3xl font-extrabold text-[#111111] sm:text-4xl">Our Mission &amp; Vision</h2>
          <div className="mt-4 space-y-3 text-sm leading-7 text-[#4e4741]">
            <p>
              <strong>Mission:</strong> To revolutionize fleet and logistics operations through real-time tracking,
              intelligent automation, and data-driven insights. We empower businesses with technology that drives
              performance, reduces costs, and maximizes operational control.
            </p>
            <p>
              <strong>Vision:</strong> To be a global leader in smart mobility solutions by making fleets safer,
              faster, and more efficient. We envision a future where every vehicle on the road is connected,
              intelligent, and optimized for impact.
            </p>
          </div>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a
              href="#solutions"
              className="inline-flex h-12 items-center justify-center rounded-xl bg-[#e68612] px-6 text-sm font-semibold text-white"
            >
              Explore Solutions
            </a>
            <Link
              to="/contact"
              className="inline-flex h-12 items-center justify-center rounded-xl border border-[#2a201b] px-6 text-sm font-semibold text-[#2a201b]"
            >
              Contact us
            </Link>
          </div>
        </div>

        <div className="space-y-3">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center justify-between rounded-2xl bg-[#e68612] px-6 py-4 text-white shadow-soft">
              <div className="flex h-10 w-10 items-center justify-center rounded-full border border-white/40 text-xl">
                &#9786;
              </div>
              <div className="text-4xl font-extrabold">{stat.value}</div>
              <div className="max-w-[7rem] text-right text-sm font-medium text-white/90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MissionVisionSection;
